import React, { Component } from 'react'
import { connect } from 'react-redux'
import TextField from '../../../components/TextInput';
import Dialog from '../../../components/Dialog';
import FlatButton from '../../../components/Buttons/SaveButton';
import SearchIcon from '../../../components/Icons/SearchIcon'
import RestoreIcon from '../../../components/Icons/RestoreIcon'
import DeleteIcon from '../../../components/Icons/DeleteIcon'
import CloudIcon from '../../../components/Icons/CloudIcon'
import { req, isAllowed } from '../../../util'
import { toggleLoading, toggleSnackBar } from '../../../redux/actions'


const mapStateToProps = state => ({
    user: state.user
})

const mapDispatchToProps = dispatch => ({
    toggleLoading: () => dispatch(toggleLoading()),
    toggleSnackBar: msg => dispatch(toggleSnackBar(msg))
})

class UsersView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            users: [],
            deleteDialog: false,
            resetDialog: false,
            sessionDialog: false,
            sessionToken: "",
            newPassword: '',
            user: {},
            search: "",
        }
    }

    getUsers = () => {
        let { toggleLoading, toggleSnackBar } = this.props;
        toggleLoading()
        req("GET", "auth/users")
            .then(res => {
                let { success, msg, users } = res;
                if (success) {
                    this.setState({ users })
                    toggleLoading()
                    return
                }
                toggleSnackBar(msg || "")
                return
            })
            .catch(e => {
                toggleLoading()
                toggleSnackBar('هنالك مشكلة في الشبكة !!')
                console.error(e)
            })
    }

    onTextChange = (e) => this.setState({ [e.target.name]: e.target.value })


    handleDeleteUser = (user) => {
        this.setState({ user, deleteDialog: true })
    }

    handleCloudLink = (user) => {
        req("POST", "app/token", { id: user.id }).then(res => {
            let { success, data, msg } = res;
            toggleLoading()
            if (success) {
                this.setState({ sessionToken: data, sessionDialog: true, user })
                toggleLoading()
            } else {
                toggleSnackBar(msg || "")
            }
        }).catch(e => {
            toggleLoading()
            toggleSnackBar("هنالك مشكلة في الشبكة !!!")
            console.error(e)
        })
    }

    handleResetUser = (user) => {
        this.setState({ user, resetDialog: true })
    }

    handleDialog = () => {
        this.setState({ deleteDialog: !this.state.deleteDialog })
    }

    handleResetDialog = () => {
        this.setState({ resetDialog: !this.state.resetDialog })
    }

    handleSessionDialog = () => {
        this.setState({ sessionDialog: false, sessionToken: "", user: {} })
    }

    deleteUser = () => {
        let { user } = this.state;
        let { toggleLoading, toggleSnackBar } = this.props;
        this.setState({ deleteDialog: false })
        toggleLoading()
        req("DELETE", "auth/users", { id: user.id }).then(res => {
            let { success, msg } = res;
            if (success) {
                toggleLoading();
                this.getUsers()
            } else {
                toggleSnackBar(msg || "")
            }
        }).catch(e => {
            toggleLoading()
            toggleSnackBar("هنالك مشكلة في الشبكة !!!")
            console.error(e)
        })
    }

    resetUser = () => {
        let { user, newPassword } = this.state;
        let { toggleLoading, toggleSnackBar } = this.props;
        this.setState({ resetDialog: false })
        toggleLoading()
        req("POST", "auth/users/reset", { id: user.id, newPassword }).then(res => {
            let { success, msg } = res;
            if (success) {
                toggleLoading();
                toggleSnackBar(`تم استرجاع حساب المستخدم ${user.name}`)
                this.setState({ newPassword: "" })
            } else {
                toggleLoading();
                toggleSnackBar(msg || "")
            }
        }).catch(e => {
            toggleLoading()
            toggleSnackBar("هنالك مشكلة في الشبكة !!!")
            console.error(e)
        })
    }


    componentWillMount = () => {
        let { user, history } = this.props;
        if (!user.loggedIn) return history.push('/login')
        if (!isAllowed(user.user, ["ADMIN"])) return history.push('/unauthrized')
        this.getUsers()
    }


    render() {
        let { user, deleteDialog, resetDialog, sessionDialog, sessionToken, newPassword, users, search } = this.state;
        users = users.filter(i => i.username.includes(search))
        let tableData = users.map(d => {
            return (
                <tr key={d.id} className="flex w-full border-b border-grey-50 px-1 py-2">
                    <td className="px-2 w-2/6 cursor-pointer text-vivid-700 font-semibold" onClick={() => { this.props.history.push(`/settings/users/${d.id}`) }}>{d.username}</td>
                    <td className="px-2 w-1/6">{d.name}</td>
                    <td className="w-1/6">{d.status ? <div className="rounded-full h-6 w-16 flex items-center justify-center text-xs font-semibold bg-cyan-500 text-grey-100">فعــال</div> : <div className="rounded-full h-6 w-16 flex items-center justify-center text-xs font-semibold bg-red-500 text-grey-100">غير فعال</div>}</td>
                    <td className="px-6 w-1/6" onClick={this.handleResetUser.bind(this, d)} ><DeleteIcon /></td>
                    <td className="px-6 w-1/6" onClick={this.handleCloudLink.bind(this, d)} ><CloudIcon className="w-4 h-4 mx-2 cursor-pointer" fill={"green"} /></td>
                    <td className="px-4 w-1/6" onClick={this.handleDeleteUser.bind(this, d)} ><RestoreIcon /></td>
                </tr>
            )
        })

        return (
            <div className="lg:m-6">
                <div className="border border-grey-100 shadow m-4 rounded bg-white">
                    <div className="text-gray-900 lg:text-lg mr-4 mt-4 font-semibold">المستخدمين</div>
                    <div className="mr-3 ml-3 pb-3">
                    </div>
                    <div className="flex justify-between pt-3">
                        <div className="relative mr-4 mt-2">
                            <input type="text" name="search" value={search} placeholder="بحـث عن مستخدم" onChange={this.onTextChange} className="text-gray-900 bg-grey-050 h-8 px-5 pr-10 rounded text-sm border border-grey-100 leading-tight focus:outline-none focus:bg-white focus:border-grey-200" />
                            <button className="absolute right-0 top-0 mt-3 mr-4 disabled cursor-not-allowed">
                                <SearchIcon />
                            </button>
                        </div>
                    </div>
                    <div className="m-4 border-2 rounded border-grey-200">
                        <table className="text-left w-full">
                            <thead className="flex text-right font-semibold text-gray-600 w-full ">
                                <tr className="flex w-full bg-grey-050 border-b-2 items-center border-grey-200">
                                    <th className="p-1 px-3 w-2/6">اسم المستخدم</th>
                                    <th className="p-1 px-3 w-1/6">الاسم</th>
                                    <th className="p-1 px-3 w-1/6"> الحالة</th>
                                    <th className="p-1 px-3 w-1/6">استرجاع</th>
                                    <th className="p-1 px-3 w-1/6">رابط كلاود</th>
                                    <th className="p-1 px-3 w-1/6">الحـذف</th>
                                </tr>
                            </thead>
                            <tbody className="flex flex-col items-center text-md text-right w-full overflow-y-scroll h-64" id="feed">
                                {tableData}
                            </tbody>
                        </table>
                    </div>
                </div>
                <Dialog
                    isOpen={deleteDialog}
                    onRequestClose={this.handleDialog}
                >
                    هل انت متاكد من حذف المستخدم {<b style={{ color: 'red' }}>{user.name}</b>} ؟
                    <div className="flex justify-start m-4">
                        <FlatButton
                            text="متأكد"
                            onClick={this.deleteUser}
                        />
                        <FlatButton
                            text="الغاء"
                            onClick={this.handleDialog}
                        />
                    </div>
                </Dialog>
                <Dialog
                    isOpen={resetDialog}
                    onRequestClose={this.handleResetDialog}
                >
                    <div className="m-4">
                        هل انت متاكد من استرجاع حساب المستخدم {<b style={{ color: 'red' }}>{user.name}</b>} ؟
                        <p></p>
                    </div>
                    <TextField
                        placeholder="كلمة السر الجديدة"
                        type="password"
                        value={newPassword}
                        onChange={(evt) => this.setState({ newPassword: evt.target.value })}
                    />
                    <div className="flex justify-center m-4">
                        <FlatButton
                            text="متأكد"
                            onClick={this.resetUser}
                        />
                        <FlatButton
                            text="الغاء"
                            onClick={this.handleResetDialog}
                        />
                    </div>
                </Dialog>
                <Dialog
                    isOpen={sessionDialog}
                    onRequestClose={this.handleSessionDialog}
                    onClose={this.handleSessionDialog}
                    title="رابط الدخول الى تطبيق بدي كار"
                >
                    <div className="m-4">
                        تم توليد رابط الدخول الى تطبيق بدي كار يعمل لمرة واحد فقط للمستخدم {user.name}
                    </div>
                    <div className="m-4">
                        <p
                            className='w-full border rounded p-2 m-2'
                        >
                            https://bodycarapp.wavesys.io?token={sessionToken}
                        </p>

                        <p
                            className='w-full border rounded p-2 m-2'
                        >
                            {sessionToken}
                        </p>

                        <div className='flex'>
                            <FlatButton
                                text="نسخ الرابط"
                                onClick={() => {
                                    navigator.clipboard.writeText(`https://bodycarapp.wavesys.io?token=${sessionToken}`)
                                }}
                                bgColor='#2680C2'

                            />
                            <FlatButton
                                text="نسخ الرمز"
                                onClick={() => {
                                    navigator.clipboard.writeText(sessionToken)
                                }}
                                bgColor='#2680C2'
                            />
                        </div>
                    </div>
                </Dialog>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersView)